import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetPaymentVoucherCommand extends IRequestCommand<
  IGetPaymentVoucherResponse,
  ErrorDetails,
  IGetPaymentVoucherCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/checkingAccount/{idMovement}/voucher';
  public override setParameters(parameters: IGetPaymentVoucherCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{idMovement}',
      parameters.paymentId.toString()
    );
  }
}

export interface IGetPaymentVoucherCommandParameters
  extends ICommandParameters {
  paymentId?: string;
}

export interface IGetPaymentVoucherResponse extends ICommandResponse {
  voucher: string;
  voucherName: string;
}
